import { render, staticRenderFns } from "./ProductGroupDetail.vue?vue&type=template&id=36df000a&"
import script from "./ProductGroupDetail.vue?vue&type=script&lang=js&"
export * from "./ProductGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupDetail.vue?vue&type=style&index=0&id=36df000a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports